var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { ChevronLink, TextButton, Link, Spinner } from '@telus-uds/components-web';
import { omit } from 'lodash';
import styled from 'styled-components';
import { RICH_TEXT_TYPES } from '../../types';
var INLINES = RICH_TEXT_TYPES.INLINES;
export var buildHyperlinkFunctions = function (_a) {
    var _b;
    var renderChevronLink = _a.renderChevronLink, openLinksInNewTab = _a.openLinksInNewTab, linkOptions = _a.linkOptions, DrawerLinkComponent = _a.DrawerLinkComponent, renderTextButton = _a.renderTextButton, link = _a.link;
    var resolvedLinkOptions = omit(linkOptions, ['variant']);
    var linkColors = {
        inverse: link === 'inverse',
        alternative: link === 'alternative'
    };
    var resolvedVariant = __assign(__assign({}, linkOptions === null || linkOptions === void 0 ? void 0 : linkOptions.variant), linkColors);
    return _b = {},
        _b[INLINES.HYPERLINK] = function (node, children) {
            if (renderChevronLink) {
                return (_jsx(ChevronLink, __assign({ href: node.data.uri, direction: linkOptions === null || linkOptions === void 0 ? void 0 : linkOptions.chevronDirection }, (openLinksInNewTab && { hrefAttrs: { target: '_blank' } }), { children: children })));
            }
            if (renderTextButton) {
                var spinner = renderTextButton.spinner, _a = renderTextButton.inlineButton, inlineButton = _a === void 0 ? true : _a;
                var StyledTextButton = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
                return (_jsx(StyledTextButton, { as: inlineButton ? 'span' : 'div', children: _jsx(Spinner, { inline: true, show: spinner, variant: { size: 'small' }, children: _jsx(TextButton, __assign({}, resolvedLinkOptions, { variant: resolvedVariant, children: children })) }) }));
            }
            if (DrawerLinkComponent)
                return DrawerLinkComponent({ children: children });
            return (_jsx(Link, __assign({ href: node.data.uri }, resolvedLinkOptions, { variant: resolvedVariant }, (openLinksInNewTab && { hrefAttrs: { target: '_blank' } }), { children: children })));
        },
        _b;
};
var templateObject_1;
